import gql from 'graphql-tag';

const searchStockAssets = gql`
  query searchStockAssets($organisationId: ID!, $parameters: StockAssetSearchParameters!, $isShutterStockUnlimited: Boolean) {
    searchStockAssets(input: { organisationId: $organisationId, parameters: $parameters, isShutterStockUnlimited: $isShutterStockUnlimited }) {
      assets {
        thumbMp4
        previewMp4
        thumbJpg
      }
      mediaType,
      id
      source
      description
      duration
      aspectRatio
      url
      contributor {
        id
      }
      cost
    }
  }
`;















export default ((organisationId) => ({
  query: searchStockAssets,
  module: 'stock-assets',
  ignoreCache: true,
  buildVariables: ({
    parameters,
    isShutterStockUnlimited
  }) => ({
    parameters,
    organisationId,
    isShutterStockUnlimited
  })
}));